<script setup>

</script>

<template>
  <h1>Sales</h1>
</template>

<style scoped>

</style>
